import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Accordion, Panel, Button, Col} from 'react-bootstrap';
import PageTitle from "../common/page-title/index";
import ArrowButton from '../common/button-arrow';
import {getPages} from '../../actions/pages';
import OnePage from './one-page';
import './styles.css';
import PageFilter from "./PageFilter";


class Pages extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentWillMount() {
    this.props.dispatch(getPages());
  }

  render() {
    const {fetched, pages} = this.props;
    if (fetched) {
      const panels = Object.keys(pages).map((pageKey, indexOut) => {

        return pageKey !== "meta" &&
          (
            <Panel key={`page-parent-${indexOut}`}
                   eventKey={`page-parent-${indexOut}`}
                   header={<div><Button bsStyle="link">{pageKey}</Button></div>}>
              {pages[pageKey].map((page, indexIn) => (
                <PageFilter key={indexIn} name={page.name}>
                  <OnePage key={`page-${indexIn}`} page={page}/>
                </PageFilter>
              ))}
            </Panel>
          )
        }
      );

      return (
        <div className="container-fluid pages accordion">
          <PageTitle>Pages</PageTitle>
          <Link to="/admin/pages-add-edit">
            <ArrowButton submit={false}
                         arrow={false}
                         className="add-button"
                         permissions={{
                           action:       'new',
                           subjectClass: 'Page'
                         }}>New page</ArrowButton>
          </Link>
          <Accordion>{panels}</Accordion>
        </div>
      );
    }
    return (
      <div/>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pages:    state.pages.pages,
    fetched:  state.pages.fetched,
    fetching: state.pages.fetching,
  };
};

export default connect(mapStateToProps)(Pages);


// WEBPACK FOOTER //
// ./src/components/pages/index.jsx